import { SearchService } from 'app/components/search/search.service';
import { Injectable, OnInit } from '@angular/core';
import { Filter } from './shared-data.model';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '../components/utils/utils.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  
  private isMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  //Tener en cuenta en que orden estan los atributos para ver como se agregan
  searchConfig: Filter = {
    selectedCountries: new Array(''),
    selectedSectors: new Array(''),
    selectedHomeOds: new Array(''),
    filter: new Array(''),
    brand: '',
    lang: '',
  };

  // Constructor que inyecta los servicios necesarios
  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private searchService: SearchService,
    private translateService: TranslateService,
    private utilsService: UtilsService
  ) {}

  // Método que actualiza la URL basada en la configuración de búsqueda
  updateUrl() {
    // Obtiene la configuración de búsqueda actual
    let temp = this.searchService.getSearchConfig();

    // Asigna los valores de configuración de búsqueda a las propiedades del objeto searchConfig
    this.searchConfig.selectedCountries = temp['selectedCountries'];
    this.searchConfig.filter = temp['filter'];
    this.searchConfig.lang = this.utilsService.mapLanguageCode(this.translateService.currentLang);
    this.searchConfig.brand = temp['brand'];
    this.searchConfig.selectedSectors = temp['selectedSectors'];
    this.searchConfig.selectedHomeOds = temp['selectedHomeOds'];

    // Llama al método para transformar la URL con la nueva configuración
    this.transformUrl(this.searchConfig);
  }

  // Método específico para actualizar solo el idioma en la URL
  updateLanguageInUrl() {
    const baseUrl = this.getBaseUrl();
    const currentParams = new URLSearchParams(window.location.search);
    
    // Actualizar el parámetro de idioma
    currentParams.set('lang', this.utilsService.mapLanguageCode(this.translateService.currentLang));
    
    // Construir la nueva URL
    const newUrl = `${baseUrl}?${currentParams.toString()}`;
    
    // Reemplazar el estado de la URL
    this.location.replaceState(newUrl);
  }

  // Método para obtener la URL base (ruta después del dominio)
  getBaseUrl(): string {
    // Obtiene la ruta actual del navegador, excluyendo los parámetros de consulta
    const path = this.router.url.split('?')[0];
    return `${path}`;
  }

  // Método que transforma y actualiza la URL en el navegador
  transformUrl(filter: any) {
    // Obtiene la URL base
    const baseUrl = this.getBaseUrl();
    console.log('transformUrl', baseUrl);
    const params = new URLSearchParams();

    // Itera sobre las claves del objeto filtro para agregar parámetros de consulta
    Object.keys(filter).forEach(key => {
      if (Array.isArray(filter[key])) {
        // Si el valor es un array, agrega cada elemento como un parámetro separado
        filter[key].forEach((value: string | number) => {
          params.append(key, value.toString());
        });
      } else if (filter[key]) {
        // Si el valor no es un array, lo agrega directamente
        params.append(key, filter[key]);
      }
    });

    // Construye la nueva URL con los parámetros de consulta
    const newUrl = `${baseUrl}?${params.toString()}`;
    
    // Reemplaza el estado de la URL en el navegador sin recargar la página
    this.location.replaceState(newUrl);
  }
  
  getIsMobile(): Observable<boolean> {
    return this.isMobile.asObservable();
  }

  setIsMobile(active: boolean): void {
    this.isMobile.next(active);
  }

}
